// Test IDs pour le cockpit : dashboard, score culture, alertes, graphiques, pages.
export const DASHBOARD = { container: 'dashboard-container' };

export const SCORE = {
  container: 'culture-score-container',
  value: 'culture-score-value',
  label: 'culture-score-label',
};

export const ALERTS = {
  container: 'alerts-panel-container',
  item: 'alert-item',
};

export const CHARTS = {
  radar: 'chart-radar-performance',
  fieldActivity: 'chart-field-activity',
  findingsPie: 'chart-findings-pie',
  monthlyEvolution: 'chart-monthly-evolution',
  topRisks: 'chart-top-risks',
  ranking: 'chart-ranking',
  heatmap: 'chart-heatmap',
  accidentsInjuryPie: 'chart-accidents-injury-pie',
  accidentsRelatedToPie: 'chart-accidents-related-to-pie',
};

export const PAGES = {
  findings: 'page-findings',
  actions: 'page-actions',
  ccv: 'page-ccv',
  pced: 'page-pced',
  indicateurs: 'page-indicateurs',
  classements: 'page-classements',
  scoreBog: 'page-score-bog',
  accidents: 'page-accidents',
};
